import React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import CheckIcon from "@mui/icons-material/Check";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import { useLanguage } from "contexts/LanguageContext";
import translations from "../../Import/translations";

// Custom connector with active/completed color
const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 16,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: theme.palette.grey[400],
    borderRadius: 1,
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: "#0162DD",
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: "#0162DD",
  },
}));

// Step icon with number
const ColorlibStepIconRoot = styled("div")(({ ownerState }) => ({
  backgroundColor: ownerState.active || ownerState.completed ? "#0162DD" : "#fff",
  color: ownerState.active || ownerState.completed ? "#fff" : "#000",
  zIndex: 1,
  width: 32,
  height: 32,
  display: "flex",
  borderRadius: "50%",
  border: ownerState.active || ownerState.completed ? "none" : "2px solid #ccc",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: "bold",
  fontSize: 14,
  position: "relative",

  // Animation ONLY for active step (not completed)
  ...(ownerState.active && !ownerState.completed
    ? {
        animation: "borderSpread 1.8s infinite ease-in-out",
      }
    : {}),

  // Add keyframes INSIDE the styled component
  "@keyframes borderSpread": {
    "0%": { boxShadow: "0 0 0 2px rgba(1, 98, 221, 0.6)" },
    "25%": { boxShadow: "0 0 0 4px rgba(1, 98, 221, 0.4)" },
    "50%": { boxShadow: "0 0 0 6px rgba(1, 98, 221, 0.2)" },
    "75%": { boxShadow: "0 0 0 4px rgba(1, 98, 221, 0.4)" },
    "100%": { boxShadow: "0 0 0 2px rgba(1, 98, 221, 0.6)" },
  },
}));


const StepIcon = ({ completed, active, icon }) => {
  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }}>
      {completed ? <CheckIcon sx={{ fontSize: 20, color: "#fff" }} /> : icon}
    </ColorlibStepIconRoot>
  );
};

export default function VictimStepper({ status, officer }) {
  const { language } = useLanguage();
  const t = translations[language];

  const steps = [
    { label: t.UNDER_REVIEW, number: "1" },
    { label: t.ASSIGNED, number: "2" },
    { label: t.IN_PROGRESS, number: "3" },
    { label: t.COMPLETE, number: "4" },
  ];

  // Determine current step
  const normalizedStatus = status?.toUpperCase();
  let currentStep = 0;

  if (normalizedStatus === "PENDING" && !officer) currentStep = 0;
  else if (normalizedStatus === "PENDING" && officer) currentStep = 1;
  else if (normalizedStatus === "ACCEPTED") currentStep = 2;
  else if (normalizedStatus === "COMPLETED") currentStep = 3;

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper
        alternativeLabel
        activeStep={currentStep}
        connector={<ColorlibConnector />}
        className="mt-3"
      >
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel
              StepIconComponent={(props) => (
                <StepIcon
                  {...props}
                  icon={step.number}
                  active={currentStep === index}
                />
              )}
            >
              {step.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
